export default "__VITE_ASSET__DR4RC$bR__";